import { Injectable } from '@angular/core';
import { MyAccountActions, PersonalManagerApiService } from '@my-account/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class PersonalManagerCommonEffects {
  personalManagerConfirmation$: Observable<
    MyAccountActions.GetPersonalManagerConfirmationSuccess | MyAccountActions.GetPersonalManagerConfirmationFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyAccountActions.GET_PERSONAL_MANAGER_CONFIRMATION),
      map((action: MyAccountActions.GetPersonalManagerConfirmation) => action.payload),
      switchMap((payload) =>
        this.personalManagerApiService.getInfo(payload).pipe(
          map((manager) => new MyAccountActions.GetPersonalManagerConfirmationSuccess(manager)),
          catchError((error: unknown) => of(new MyAccountActions.GetPersonalManagerConfirmationFail(error))),
        ),
      ),
    ),
  );

  approvePersonalManager$: Observable<
    MyAccountActions.ApprovePersonalManagerSuccess | MyAccountActions.ApprovePersonalManagerFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyAccountActions.APPROVE_PERSONAL_MANAGER),
      map((action: MyAccountActions.ApprovePersonalManager) => action.payload),
      switchMap((personalManagerId) =>
        this.personalManagerApiService.approveManager(personalManagerId).pipe(
          map(() => new MyAccountActions.ApprovePersonalManagerSuccess(personalManagerId)),
          catchError((error) => of(new MyAccountActions.ApprovePersonalManagerFail(personalManagerId, error))),
        ),
      ),
    ),
  );

  revokePersonalManager$: Observable<
    MyAccountActions.RevokePersonalManagerSuccess | MyAccountActions.RevokePersonalManagerFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyAccountActions.REVOKE_PERSONAL_MANAGER),
      map((action: MyAccountActions.RevokePersonalManager) => action.payload),
      switchMap((personalManagerId) =>
        this.personalManagerApiService.revokeManager(personalManagerId).pipe(
          map(() => new MyAccountActions.RevokePersonalManagerSuccess(personalManagerId)),
          catchError((error) => of(new MyAccountActions.RevokePersonalManagerFail(personalManagerId, error))),
        ),
      ),
    ),
  );

  deletePersonalManager$: Observable<
    MyAccountActions.DeletePersonalManagerSuccess | MyAccountActions.DeletePersonalManagerFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyAccountActions.DELETE_PERSONAL_MANAGER),
      map((action: MyAccountActions.DeletePersonalManager) => action.payload),
      switchMap((personalManagerId) =>
        this.personalManagerApiService.deleteManager(personalManagerId).pipe(
          map(() => new MyAccountActions.DeletePersonalManagerSuccess(personalManagerId)),
          catchError((error) => of(new MyAccountActions.DeletePersonalManagerFail(personalManagerId, error))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private personalManagerApiService: PersonalManagerApiService,
  ) {}
}
